/*
 * @ Author: wangjiyu
 * @Date: 2020-04-10 11:05:38
 * @LastEditTime: 2020-04-13 14:24:56
 * @LastEditors: wangjiyu
 * @Description: file content
 */

import emojiDialogCtrlDom from './emojiDialogCtrl';

let emojiDialogCtrl;
const emojiDialog = (selectCallback) => {
    if (!emojiDialogCtrl) emojiDialogCtrl = emojiDialogCtrlDom;
    return emojiDialogCtrl.addDialog({
        selectCallback,
    });
};

export default {
    init(initParam: { selectCallback?: (img) => void }) {
        return {
            show() {
                return emojiDialog(initParam.selectCallback);
            },
            close() {
                return emojiDialogCtrl.destroy();
            },
        };
    },
};
